import { render } from "@testing-library/react";
import dayjs from "dayjs";
import ToolTip from "../../ToolTip/ToolTip";

export const academicCalendarTableHeader = [
    {
      field: "session_date",
      headerName: "Scheduled Date",
      width: 150,
    //   renderCell: (params) => dayjs(params.row.session_date).format("MMMM D, YYYY ")
    },
    {
      field: "from_time",
      headerName: "Start Time",
      width: 100,
      renderCell: (params) => dayjs(params.row.from_time, "HH:mm:ss").format("hh:mm A")
    },
    {
        field: "to_time",
        headerName: "End Time",
        width: 100,
        renderCell: (params) => dayjs(params.row.to_time, "HH:mm:ss").format("hh:mm A")
      },
    {
      field: "rescheduled_at",
      headerName: "Rescheduled At",
      width: 200,
      renderCell: (params) => dayjs(params.row.rescheduled_at).format("MMMM D, YYYY hh:mm A")

    },

    {
        field: "reschedule_requested_by",
        headerName: "Rescheduled By",
        width: 150,
        renderCell: (params) => params.row.reschedule_requested_by==1 ? "Parent" : "Tutor"
    },
    {
        field: "rescheduled_reason",
        headerName: "Rescheduled Reason",
        width: 450,
        renderCell: (params) => {
            return(
            <ToolTip
                expand={params?.row?.rescheduled_reason || "Nill"}
                content={params?.row?.rescheduled_reason || "Nill"} />
            )
         
        }
      },
  ];
  